import { render, staticRenderFns } from "./PositionLanguages.vue?vue&type=template&id=773c025c"
import script from "./PositionLanguages.vue?vue&type=script&lang=js"
export * from "./PositionLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports